import React from 'react';
import Meal from '@app/model/market_state/Meal';
import MarketStateFilterInput from '@app/model/market_state/input/MarketStateFilterInput';
import MenuButtonFilter from '@app/component/menu/MenuButtonFilter';
import {
	useMarketStateFilterInputTools
} from '@app/site/secured/rateshopper/rates/provider/useMarketStateFilterInputTools';
import CompanyHotelDashboardFilter from '@app/model/company_hotel/settings/CompanyHotelDashboardFilter';


type DashboardSelectMealFilterProps = {
	filter: MarketStateFilterInput,
	onFilter: (filter: MarketStateFilterInput) => void
}

const DashboardSelectMealFilter = React.memo(
	function DashboardSelectMealFilter({ filter, onFilter }: DashboardSelectMealFilterProps) {
		const {isDashboardFilterEnabled} = useMarketStateFilterInputTools()
		const providerSupportsFilter = isDashboardFilterEnabled(CompanyHotelDashboardFilter.MEAL);

		const menuItems = [
			{ name: 'Any Meal', description: 'Independent of meals', value: undefined },
			{ name: 'Bed Only', description: 'Not including any meals', value: Meal.NONE },
			{ name: 'Bed & Breakfast', description: 'Has breakfast', value: Meal.BREAKFAST },
			{ name: 'Half Board', description: 'Half Board', value: Meal.HALF_BOARD },
			{ name: 'Full Board', description: 'Full Board', value: Meal.FULL_BOARD },
			{ name: 'All Inclusive', description: 'All Inclusive', value: Meal.ALL_INCLUSIVE },
		];

		const onSelect = (meal: Meal | undefined) => {
			onFilter({ ...filter, meal: meal });
		};

		return <MenuButtonFilter menuItems={menuItems}
														 selectedValue={filter.meal}
														 onSelect={onSelect}
														 disabled={!providerSupportsFilter}
														 menuDescription="Please select the meal provided in the room." />;

	},
);

export default DashboardSelectMealFilter;